// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container--F_Vqi","title":"styles-module__title--_Q45s","description":"styles-module__description--w32Lg","link":"styles-module__link--Ksbs_"};